export interface NotificationState {
  unreadCount: number;
}

export const state: NotificationState = {
  unreadCount: 0
}